import Icon from "../assets/Logos/BTC-Logo-1.svg"


export default function Logo({ sx }) {
  return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <img src={Icon} alt={'Logo'} width={150}/>
      </div>
  );
}
